var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui_radio_button', { 'vertical': this.vertical }]},[_c('a-radio-group',_vm._g(_vm._b({},'a-radio-group',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }